module.exports = {
      id: "glyph:question-usage",
      viewBox: "0 0 14 14",
      url: "/static/" + "sprites.1e5806fb7235408b9281f0924c9110c8.svg#glyph:question-usage",
      toString: function () {
        return this.url;
      }
    }